import React from 'react';
import ComponentField from '../../form/ComponentField';
import createForm from "./Form";
import Select from "src/components/form/Select";

class MaterialForm extends React.Component {

    render() {
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-md-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />    
                    </div>
                    <div className="col-md-8">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Név"
                        />    
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="energy"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kalória"
                            type="number"
                        />    
                    </div>
                    <div className="col-md-4">
                        <Select
                            name="unit"
                            storeType="local"
                            optionname="unit"
                            objectValue={false}
                            value={this.props.values.unit}
                            label="Mértékegység"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("unit")}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(MaterialForm);
